import { responsiveImage } from "../../utils";

const renderQueryRuleCustomData = (renderOptions, isFirstRender) => {
  const { items, widgetParams } = renderOptions;

  if (isFirstRender) return;

  widgetParams.container.innerHTML = "";

  // Find banner in rules
  const rules = items.find((item) => item.banner);

  // Stop if rules is undefined
  if (rules === undefined) return;

  // Stop if no banner is found
  if (!rules.banner) return;

  const { banner } = rules;

  // Stop if missing either desktop or mobile banner
  if (!banner.desktop || !banner.mobile) return;

  widgetParams.container.innerHTML = `
    ${banner.link ? `<a href="${banner.link}">` : ""}
      <figure class="img img--wrapper img--promo-banner--desktop visibility-hidden visibility-lg--visible">
        ${responsiveImage(banner.alt, banner.desktop)}
      </figure>
      <figure class="img img--wrapper img--promo-banner--mobile visibility-lg--hidden">
        ${responsiveImage(banner.alt, banner.mobile)}
      </figure>
    ${banner.link ? `</a>` : ""}
  `;
};

export const banners = window.instantsearch.connectors.connectQueryRules(
  renderQueryRuleCustomData
);
